import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { insurerService } from '../services/insurerService';

const DEFAULT_LOGO = '/insurance-partner-logo.svg';
const DEFAULT_ALT = 'Insurance Partner';

export function useInsurerLogo() {
  const { user } = useAuth();
  const isInsurer = user?.role === 'INSURER';
  const [logoSrc, setLogoSrc] = useState(DEFAULT_LOGO);
  const [logoAlt, setLogoAlt] = useState(DEFAULT_ALT);
  const [orgName, setOrgName] = useState<string | null>(null);
  const [hasLogo, setHasLogo] = useState(false);

  useEffect(() => {
    if (!isInsurer) {
      setLogoSrc(DEFAULT_LOGO);
      setLogoAlt(DEFAULT_ALT);
      setOrgName(null);
      return;
    }

    let objectUrl: string | null = null;
    let cancelled = false;

    (async () => {
      try {
        const org = await insurerService.getOrg();
        if (cancelled) return;
        if (org.name) {
          setOrgName(org.name);
        }
        setHasLogo(Boolean(org.has_logo));

        if (!org.has_logo) {
          setLogoSrc(DEFAULT_LOGO);
          setLogoAlt(org.name || DEFAULT_ALT);
          return;
        }

        objectUrl = await insurerService.getOrgLogoObjectUrl();
        if (cancelled) return;

        if (objectUrl) {
          setLogoSrc(objectUrl);
          setLogoAlt(org.name);
        } else {
          setLogoSrc(DEFAULT_LOGO);
          setLogoAlt(org.name || DEFAULT_ALT);
        }
      } catch {
        if (!cancelled) {
          setLogoSrc(DEFAULT_LOGO);
          setLogoAlt(DEFAULT_ALT);
        }
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [isInsurer]);

  return { logoSrc, logoAlt, isInsurer, orgName, hasLogo };
}
